import {
    type GetCommercialOpportunityRequestResponseType,
    type GetCommercialOpportunityRequestRequestType
} from "./type";
import {
    request
} from "../request";

const getCommercialOpportunityRequest = async (
    params: GetCommercialOpportunityRequestRequestType
): Promise<GetCommercialOpportunityRequestResponseType> => {
    return await request<GetCommercialOpportunityRequestResponseType>(
        `/request/getCommercialOpportunityRequest?requestID=${params.requestID}`,
        {
            method: "GET"
        }
    );
};
export default getCommercialOpportunityRequest;
